<template>
  <div
    v-bind="$attrs"
    v-on="{ ...$listeners, click: () => {} }"
    class="d-flex align-row linkButton"
  >
    <v-btn
      fab
      x-small
      depressed
      color="primary"
      @click="$listeners.click"
      class="mr-1 elevation-3"
      >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <div class="my-auto">
      <a @click="$listeners.click">
        {{ text }}
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'IconButtonText',
  props: {
    onClick: Function,
    text: String
  }
}

</script>

<style lang="scss" scoped>
  .linkButton {
    &:hover {
      a {
        text-decoration: underline;
      }
    }
  }
</style>
